module.exports = __webpack_public_path__ + "static/media/check.09e93e42.PNG";